import $ from 'jquery';
import Highcharts from 'highcharts';
import * as Nested from '../core/nested-property-helpers.js';
import {addMediaQueryListener, newStyleSheet} from '../core/style-helpers.js';

function chartReflow(chart) {
  if (Nested.get(chart, 'series.0.type') == 'treemap') {
    var animation = Nested.get(chart,'series.0.options.animation') || false;
    Nested.set(chart, 'series.0.options.animation', false);
    chart.reflow();
    Nested.set(chart, 'series.0.options.animation', animation);
  } else {
    var scrollablePlotArea = Nested.get(chart,'options.scrollablePlotArea');
    if (scrollablePlotArea) {
      Nested.set(chart, 'options.scrollablePlotArea', null);
      chart.reflow();
      Nested.set(chart, 'options.scrollablePlotArea', scrollablePlotArea);
    } else {
      chart.reflow();      
    }
  }
}

function t(t){if(t.series[0]&&t.series[0].tree){var e=t.series[0].options.animation;t.series[0].options.animation=!1,t.reflow(),t.series[0].options.animation=e}else{var e=t.options.chart.scrollablePlotArea;t.options.chart.scrollablePlotArea=null,t.reflow(),t.options.chart.scrollablePlotArea=e}}

function chartsReflow() {
  Highcharts.charts.forEach(chartReflow);
}

var printSupportAdded = false,
    stylesheet = newStyleSheet('print');

stylesheet.insertRule(".dsib-highcharts svg g.highcharts-exporting-group { display: none; }", 0);

if (!!window.chrome && !window.navigator.msPointerEnabled) {
  stylesheet.insertRule(".dsib-highcharts {\
      -webkit-print-color-adjust: exact !important;\
      color-adjust: exact !important;\
      -webkit-column-break-inside: avoid;\
      page-break-inside: avoid;\
      break-inside: avoid;\
    }");

  Highcharts.Chart.prototype.callbacks.push( function(chart) {
    if (!printSupportAdded) {
      printSupportAdded = true;
      $(window).on('beforeprint.highchart', function() {
        var rl = addMediaQueryListener('print', chartsReflow, chartsReflow);
        $(window).one('afterprint.highchart', function() {
          rl();
        });
      });
    }
  });
} else {
  stylesheet.insertRule(".dsib-highcharts {\
      position:relative;\
      -webkit-print-color-adjust: exact !important;\
      color-adjust: exact !important;\
      -webkit-column-break-inside: avoid;\
      page-break-inside: avoid;\
      break-inside: avoid;\
    }", 1);
  stylesheet.insertRule(".dsib-highcharts::after {\
      content: 'Sorry, printing charts is only supported in Chromium-based browser (excluding MS-Edge)';\
      display: flex;\
      position: absolute;\
      top: 0;\
      z-index: 100000000;\
      width: 100%;\
      height: 100%;\
      background-color: rgba(255, 255, 255, 0.9);\
      color: #444;\
      font-size: 36px;\
      text-align: center;\
      justify-content: center;\
      align-items: center;\
    }", 2);
}